import IntroWizardsStep from '@/components/intro-wizards/intro-wizards-step/intro-wizards-step';
import IntroWizardCover from './components/intro-wizard-cover/intro-wizard-cover';
import IntroWizardStepDescription from './components/intro-wizard-step-description/intro-wizard-step-description';
import IntroWizardStepTitle from './components/intro-wizard-step-title/intro-wizard-step-title';
import useModalIntroWizard from './intro-wizard.controller';
import IntroWizardStep05 from './components/intro-wizard-step-05/intro-wizard-step-05';

type IntroWizardProps = {
  onFinish: () => void;
};

export default function IntroWizard(props: IntroWizardProps) {
  const { handleNextButtonClick, handleBackButtonClick, activeStep, activeStepIndex, numberOfSteps, buttonText } =
    useModalIntroWizard(props);

  function renderSwitch(activeStep: number) {
    switch (activeStep) {
      case 0: {
        return <IntroWizardCover onNextButtonClick={handleNextButtonClick} onBackButtonClick={handleBackButtonClick} />;
      }
      case 5: {
        return (
          <IntroWizardStep05 onNextButtonClick={handleNextButtonClick} onBackButtonClick={handleBackButtonClick} />
        );
      }
      default: {
        return (
          <IntroWizardsStep
            titleNode={<IntroWizardStepTitle activeStep={activeStep} />}
            descriptionNode={<IntroWizardStepDescription activeStep={activeStep} />}
            imageId="phone"
            activeStepIndex={activeStepIndex}
            numberOfSteps={numberOfSteps}
            onNextButtonClick={handleNextButtonClick}
            onBackButtonClick={handleBackButtonClick}
            buttonText={buttonText}
          />
        );
      }
    }
  }

  return renderSwitch(activeStep);
}
